import { ChartOptions } from "chart.js";

const totalDuration = 1000;
const delayBetweenPoints = (data) => totalDuration / data.length;
const previousY = (ctx) =>
  ctx.index === 0
    ? ctx.chart.scales.y.getPixelForValue(100)
    : ctx.chart
        .getDatasetMeta(ctx.datasetIndex)
        .data[ctx.index - 1].getProps(["y"], true).y;
export const getOptions = (
  polarizeColors: boolean,
  data: number[],
  disableAnimation: boolean
): ChartOptions<"line"> => {
  return {
    scales: {
      y: {
        ticks: {
          display: false,
        },
        border: {
          display: false,
        },
        grid: {
          color: "transparent",
          display: polarizeColors,

          lineWidth: 0.5,
        },
      },
      x: { display: false },
    },
    maintainAspectRatio: false,
    layout: {
      padding: {
        bottom: 2,
      },
    },
    animation: {
      //https://www.chartjs.org/docs/latest/samples/animations/progressive-line.html
      //@ts-ignore
      x: {
        type: "number",
        easing: "linear",
        duration: !disableAnimation && delayBetweenPoints(data),
        from: NaN, // the point is initially skipped
        delay:
          !disableAnimation &&
          function (ctx) {
            if (ctx.type !== "data" || ctx.xStarted) {
              return 0;
            }
            ctx.xStarted = true;
            return ctx.index * delayBetweenPoints(data);
          },
      },
      y: {
        type: "number",
        easing: "linear",
        duration: delayBetweenPoints(data),
        from: previousY,
        delay: disableAnimation
          ? 0
          : function (ctx) {
              if (ctx.type !== "data" || ctx.yStarted) {
                return 0;
              }
              ctx.yStarted = true;
              return ctx.index * delayBetweenPoints(data);
            },
      },
    },

    animations: { active: { duration: 0 }, resize: { duration: 0 } },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      //@ts-ignore: datalabels is properly imported and registered on the chart
      datalabels: {
        display: false,
      },
      //@ts-ignore
      chartPolarizeColors: polarizeColors,
    },
  };
};
